import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateOrganizationRequestBody,
  IApiGetOrganizationResponseBody,
} from '../OrganizationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { onboardingStatusQueryKeyFactory } from '../../Onboarding/hooks/useOnboardingStatusQuery';
import { organizationQueryKeyFactory } from './useOrganizationQuery';
import { organizationsQueryKeyFactory } from './useOrganizationsQuery';

export const useCreateOrganizationMutation = (): UseMutationResult<
  IApiGetOrganizationResponseBody,
  unknown,
  IApiCreateOrganizationRequestBody
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: IApiCreateOrganizationRequestBody) =>
      api.organizations.create(body),
    onSuccess: async (createdOrganization) => {
      queryClient.setQueryData(
        organizationQueryKeyFactory({
          organizationId: createdOrganization._id,
        })!,
        createdOrganization,
      );

      await queryClient.invalidateQueries({
        queryKey: organizationsQueryKeyFactory(),
      });

      await queryClient.invalidateQueries({
        queryKey: onboardingStatusQueryKeyFactory({
          body: {
            target: 'user',
          },
        }),
      });
    },
  });
};
